import { SearchIcon } from "@chakra-ui/icons";
import {
    InputGroup,
    InputLeftElement,
    Input,
    InputGroupProps,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { debounce } from "underscore";

interface InputSearchProps extends InputGroupProps {
    size?: "sm" | "md" | "lg";
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    debounceTime?: number;
    placeholder?: string;
}

export default function InputSearch({
    size = "md",
    value,
    onChange,
    debounceTime = 500,
    placeholder = "Search",
    ...props
}: InputSearchProps) {
    const [searchText, setSearchText] = useState(value);

    const debouncedOnChange = debounce(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (onChange) {
                onChange(e);
            }
        },
        debounceTime
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        debouncedOnChange(e);
    };

    useEffect(() => {
        setSearchText(value);
    }, [value]);

    return (
        <InputGroup
            border="1px solid"
            borderColor="gray.100"
            size={size}
            borderRadius="8px"
            px="2px"
            {...props}
        >
            <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.200" />
            </InputLeftElement>

            <Input
                type="search"
                placeholder={placeholder}
                _placeholder={{ color: "gray.200" }}
                value={searchText}
                onChange={handleChange}
                width="100%"
            />
        </InputGroup>
    );
}
